export const actionTypes = {
  PERSONAL_DATA_PAGE_INIT: 'PROFILE.PERSONAL_DATA_PAGE.PERSONAL_DATA_PAGE_INIT',
  PERSONAL_DATA_PAGE_DESTROY: 'PROFILE.PERSONAL_DATA_PAGE.PERSONAL_DATA_PAGE_DESTROY',
};

export function personalDataPageInit() {
  return {
    type: actionTypes.PERSONAL_DATA_PAGE_INIT,
  };
}

export function personalDataPageDestroy() {
  return {
    type: actionTypes.TAX_EXEMPTIONS_REQUEST_SUCCESS,
  };
}
